import { Button, Card, Typography, Grid, withStyles, LinearProgress, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { deepPurple } from '@material-ui/core/colors'
import { useRouter } from 'next/router'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import { CryptoCard as ICryptoCard } from '../../../../../types/cryptoCard'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '40px auto',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    boxShadow: 'none',
    display: 'flex',
    borderRadius: '1rem',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    padding: '16px 24px',
    '@media (max-width: 420px)': {
      margin: '5px',
      padding: '12px',
    },
  },
  mainSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: '2rem',
    margin: '0 0',
  },
  logoContainer: {
    marginTop: '20px',
    marginBottom: '25px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    '@media (max-width: 420px)': {
      width: '100%',
      maxWidth: '100%',
      margin: '30px 0 0 0',
      justifyContent: 'flex-start',
    },
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    '@media (max-width: 420px)': {
      justifyContent: 'center',
      flexBasis: '100%',
    },
  },
  logo: {
    objectFit: 'contain',
    [theme.breakpoints.up('md')]: {
      transform: 'rotate(90deg)',
    },
  },
  description: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  leftSection: {
    width: '70%',
    '@media (max-width: 420px)': {
      width: '100%',
    },
  },
  rightSection: {
    width: '30%',
    '@media (max-width: 420px)': {
      width: '100%',
    },
  },
  descriptionSection: {
    marginBottom: '30px',
    paddingRight: '30px',
    '@media (max-width: 420px)': {
      padding: '0',
      margin: '20px auto',
      textAlign: 'center',
    },
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '25px',
    alignItems: 'center',
  },
  button: {
    marginTop: '20px',
    width: '204px',
    height: '64px',
    fontSize: '18px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  mobileButton: {
    marginTop: '20px',
    width: '204px',
    height: '64px',
    fontSize: '18px',
    display: 'none',
    '@media (max-width: 420px)': {
      margin: '20px auto',
      display: 'block',
    },
  },
  campaign: {
    color: theme.palette.primary.main,
    width: 'fit-content',
    position: 'relative',
    '& h5': {
      position: 'relative',
    },
    marginBottom: '20px',
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
    },
  },
  campaignTitle: {
    fontSize: '18px',
  },
  campaignBackground: {
    position: 'absolute',
    top: '5px',
    left: '-5px',
    width: '110%',
    backgroundColor: theme.palette.secondary.main,
    height: '26px',
  },
  rating: {
    position: 'relative',
    fontSize: '.8rem',
    '@media (max-width: 420px)': {
      fontSize: '.8rem',
    },
  },
  ratingContainer: {
    width: '100%',
    '@media (max-width: 420px)': {
      margin: '20px auto',
      alignItems: 'baseline',
    },
  },
  ratingBackground: {
    position: 'absolute',
    top: '-10px',
    left: '10px',
    width: '150px',
    backgroundColor: theme.palette.secondary.main,
    height: '61px',
    '@media (max-width: 420px)': {
      width: '120px',
      height: '40px',
      top: '2px',
    },
  },
  hideMobile: {
    '@media (max-width: 420px)': {
      display: 'none',
    },
  },
  promotionSection: {
    position: 'relative',
    width: 'fit-content',
    margin: '20px 0',
  },
  promotion: {
    backgroundColor: deepPurple['400'],
    color: 'white',
    fontWeight: 'bold',
    position: 'relative',
    '@media (max-width: 420px)': {
      fontSize: '14px',
    },
  },
  promotionBackground: {
    position: 'absolute',
    top: '10px',
    left: '-5px',
    width: '90%',
    backgroundColor: theme.palette.secondary.main,
    height: '18px',
    '@media (max-width: 420px)': {
      top: '8px',
      height: '14px',
    },
  },
  feesContainer: {
    margin: '1rem 0',
    '& > p': {
      fontFamily: theme.typography.h1.fontFamily,
    },
    '& > p > span': {
      fontWeight: 'bold',
    },
  },
  actionSection: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '1rem 0',
    '& button': {
      margin: '0 1rem',
      textTransform: 'none',
      borderRadius: '1rem',
    },
    '& a': {
      fontSize: '.8rem',
      borderBottom: '1px solid black',
    },
  },
  markdown: {
    margin: '0',
    fontSize: '18px',
    color: '#555555',
    lineHeight: '1.8em',
    overflowWrap: 'break-word',
    '& img': {
      maxWidth: '100%',
    },
    '& a': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    '& p': {
      margin: '0',
    },
  },
  sectionTitle: {
    fontWeight: 600,
    textTransform: 'capitalize',
    letterSpacing: '1px',
  },
  sectionValue: {
    color: ' rgba(43, 24, 65, 1) !important',
    fontWeight: 600,
  },
}))

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 6,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[300],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}))(LinearProgress)

interface Props {
  card: ICryptoCard
}

function WalletCard({ card }: Props): JSX.Element {
  const classes = useStyles({})
  const { push } = useRouter()

  const goToReview = () => push(card.url)
  const rating = card.rating

  return (
    <Card className={classes.root}>
      <div className={classes.mainSection}>
        <div className={classes.logoContainer}>
          <Grid container spacing={2}>
            <Grid container justify="center" item xs={12} md={3}>
              <img
                width={320}
                height={320}
                src={`${card.card_image && card.card_image.url}`}
                className={classes.logo}
                alt={`${card.card_image.name} logo`}
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <div className={classes.titleContainer}>
                <Typography variant="h3" className={classes.title}>
                  {card.name}
                </Typography>
              </div>
              {rating && (
                <Grid
                  className={classes.ratingContainer}
                  item
                  container
                  justify="center"
                  alignItems="center"
                  xs={12}
                  md={8}
                  spacing={1}
                >
                  <Grid item xs={12} md={8}>
                    <BorderLinearProgress variant="determinate" value={(rating / 5) * 100} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="h3" className={classes.rating}>
                      {rating.toFixed(1)} out of 5
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {card.annual_fee && (
                <div className={classes.feesContainer}>
                  <Typography variant="body2">
                    Annual Fee :<span> {card.annual_fee}</span>
                  </Typography>
                </div>
              )}

              {card.provider && (
                <div className={classes.descriptionSection}>
                  <Typography variant="subtitle1" className={classes.sectionTitle}>
                    PROVIDER
                  </Typography>
                  <div className={classes.description}>
                    {card.provider && (
                      <ReactMarkdown className={classes.markdown}>{card.provider}</ReactMarkdown>
                    )}
                  </div>
                </div>
              )}
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      ASSETS
                    </Typography>
                    <Typography className={classes.sectionValue}>
                      {card.cryptocurrencies.map(
                        (currency, index, currencies) =>
                          `${currency.name}${index < currencies.length - 1 ? ', ' : '.'}`,
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      FIAT CURRENCIES
                    </Typography>
                    <Typography className={classes.sectionValue}>
                      {card.fiats.map(
                        (fiat, index, fiats) =>
                          `${fiat.name}${index < fiats.length - 1 ? ', ' : '.'}`,
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </div>

              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      Foreign Currency Fee
                    </Typography>
                    <Typography className={classes.sectionValue}>
                      {card.foreign_currency_fee}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      Crypto-Fiat Conversion
                    </Typography>
                    <Typography className={classes.sectionValue}>{card.conversion_fee}</Typography>
                  </Grid>
                </Grid>
              </div>

              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      REWARDS
                    </Typography>
                    <Typography>{card.rewards}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      FIAT TOP-UPS
                    </Typography>
                    <Typography>{card.fiat_deposits ? 'Yes' : 'No'}</Typography>
                  </Grid>
                </Grid>
              </div>

              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      ATM WITHDRAWALS
                    </Typography>
                    <Typography className={classes.sectionValue}>{card.atm_withdrawals}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.sectionTitle}>
                      AUTOMATIC CRYPTO CONVERSION
                    </Typography>
                    <Typography className={classes.sectionValue}>
                      {card.automatic_crypto_conversions ? 'Yes' : 'No'}
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.infoSection}>
          <div className={classes.actionSection}>
            <div>
              <Button variant="contained" color="primary" onClick={goToReview} disableElevation>
                Get {card.name} now!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default WalletCard
